export default {
  'settlementDetails.sectionTitle': 'Settlement Details',
  'settlementDetails.title': 'Settlement details',

  'settlementDetails.button.backToSettlements': 'Back to settlements',
  'settlementDetails.settlementId': 'Settlement ID',
  'settlementDetails.settlementStatus': 'Settlement status',
  'settlementDetails.settlementDates': 'Dates',
  'settlementDetails.settlementAmount': 'Amount',

  'settlementDetails.error.title.fetchingDetails': 'Settlement details',
  'settlementDetails.error.message.fetchingDetails':
    'Error fetching settlement details',

  'settlementDetails.modal.title': 'Mark settlement',
  'settlementDetails.modal.content':
    'Are you sure you want to mark as processed?',
  'settlementDetails.modal.action.yes': 'Yes',
  'settlementDetails.modal.action.no': 'No',
};
